export default __webpack_public_path__ + "static/media/QuickRecharger.e046cc2d.png";